angular.module("app").controller("LogoPageController", [
    '$scope', 'logoService', 'logger', 'errorHandler', 'preloadedLogos',
    function ($scope, logoService, logger, errorHandler, preloadedLogos) {
        $scope.state = {
            name: "header"
        };
        var initialHeaderLogoHeight = "";
        var initialHeaderLogoWidth = "";
        var initialHeaderMiniLogoHeight = "";
        var initialHeaderMiniLogoWidth = "";

        $scope.headerLogo = {height: "", width: ""};
        $scope.headerMiniLogo = {height: "", width: ""};
        $scope.formsLogo = {};
        $scope.favicon = {};
        $scope.footerSprite = {};
        $scope.mobileLogo = {};

        /**
         * Load logos from back end response
         * @param response
         */
        function loadLogos(response){
            if (response.header_logo) {
                $scope.headerLogo.image = response.header_logo.image;
                $scope.headerLogo.width = response.header_logo.width || "";
                $scope.headerLogo.height = response.header_logo.height || "";
                initialHeaderLogoHeight = $scope.headerLogo.height;
                initialHeaderLogoWidth = $scope.headerLogo.width;
            } else {
                $scope.headerLogo.image = undefined;
                initialHeaderLogoHeight = "";
                initialHeaderLogoWidth = "";
            }

            if (response.header_mini_logo){
                $scope.headerMiniLogo.image = response.header_mini_logo.image;
                $scope.headerMiniLogo.width = response.header_mini_logo.width || "";
                $scope.headerMiniLogo.height = response.header_mini_logo.height || "";
                initialHeaderMiniLogoHeight = $scope.headerMiniLogo.height;
                initialHeaderMiniLogoWidth = $scope.headerMiniLogo.width;
            } else {
                $scope.headerMiniLogo.image = undefined;
                initialHeaderMiniLogoHeight = "";
                initialHeaderMiniLogoWidth = "";
            }

            if (response.forms_logo) {
                $scope.formsLogo.image = response.forms_logo.image;
            } else {
                $scope.formsLogo.image = undefined;
            }

            if (response.favicon) {
                $scope.favicon.image = response.favicon.image;
            } else {
                $scope.favicon.image = undefined;
            }

            if (response.imageInsteadPayments) {
                $scope.footerSprite.image = response.imageInsteadPayments.image;
            } else {
                $scope.footerSprite.image = undefined;
            }

            if (response.mobile_logo) {
                $scope.mobileLogo.image = response.mobile_logo.image;
            } else {
                $scope.mobileLogo.image = undefined;
            }

        }

        loadLogos(preloadedLogos);

        /**
         * Publish data
         */
        $scope.publish = function publish() {
            $scope.headerLogo.buildResult(function (headerLogoData) {
                $scope.headerMiniLogo.buildResult(function (headerMiniLogoData) {
                    $scope.formsLogo.buildResult(function (formsLogoData) {
                        $scope.favicon.buildResult(function (faviconData) {
                            $scope.mobileLogo.buildResult(function (mobileLogoData) {
                                $scope.footerSprite.buildResult(function (footerSpriteData) {
                                    var requestData = {};
                                    headerLogoData && (requestData.header_logo = headerLogoData);
                                    requestData.header_logo = requestData.header_logo || {};
                                    $scope.headerLogo.width !== initialHeaderLogoWidth && (requestData.header_logo.width = $scope.headerLogo.width);
                                    $scope.headerLogo.height !== initialHeaderLogoHeight && (requestData.header_logo.height = $scope.headerLogo.height);
                                    if (Object.keys(requestData.header_logo).length === 0) {
                                        delete requestData.header_logo
                                    }
                                    headerMiniLogoData && (requestData.header_mini_logo = headerMiniLogoData);
                                    requestData.header_mini_logo = requestData.header_mini_logo || {};
                                    $scope.headerMiniLogo.width !== initialHeaderMiniLogoWidth && (requestData.header_mini_logo.width = $scope.headerMiniLogo.width);
                                    $scope.headerMiniLogo.height !== initialHeaderMiniLogoHeight && (requestData.header_mini_logo.height = $scope.headerMiniLogo.height);
                                    if (Object.keys(requestData.header_mini_logo).length === 0) {
                                        delete requestData.header_mini_logo;
                                    }
                                    formsLogoData && (requestData.forms_logo = formsLogoData);
                                    faviconData && (requestData.favicon = faviconData);
                                    footerSpriteData && (requestData.imageInsteadPayments = footerSpriteData);
                                    mobileLogoData && (requestData.mobile_logo = mobileLogoData );
                                    logoService.saveLogo(requestData).then(function (response) {
                                            if (response.status == "ok") {
                                                logger.logSuccess("global.successfullyPublished");
                                                logoService.loadLogo().then(function (loadingResponse) {
                                                    if (loadingResponse.status === 'ok') {
                                                        update(loadingResponse);
                                                    }

                                                }, function (failResponse) {
                                                    errorHandler(failResponse.message)
                                                })
                                            } else {
                                                errorHandler(response.message)
                                            }
                                        },
                                        function (response) {
                                            errorHandler(response.message)
                                        }
                                    );
                                });
                            });
                        })
                    })
                })
            })
        };

        /**
         * Update logos
         * @param response
         */
        function update(response){
            loadLogos(response);
            $scope.headerLogo.update();
            $scope.headerMiniLogo.update();
            $scope.formsLogo.update();
            $scope.favicon.update();
            $scope.footerSprite.update();
            $scope.mobileLogo.update();
        }

    }
]);
